"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
exports.AddIcon = function () { return (react_1.default.createElement("svg", { viewBox: "0 0 16 16" },
    react_1.default.createElement("path", { fill: "#54b948", d: "M16 6.5H9.5V0h-3v6.5H0v3h6.5V16h3V9.5H16z" }))); };
//# sourceMappingURL=AddIcon.js.map